export const FETCH_ALL = 'mailingLists/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'mailingLists/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'mailingLists/FETCH_ALL_ERROR';

export const CREATE = 'mailingLists/CREATE';
export const CREATE_SUCCESS = 'mailingLists/CREATE_SUCCESS';
export const CREATE_ERROR = 'mailingLists/CREATE_ERROR';

export const UPDATE = 'mailingLists/UPDATE';
export const UPDATE_SUCCESS = 'mailingLists/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'mailingLists/UPDATE_ERROR';

export const DELETE = 'mailingLists/DELETE';
export const DELETE_SUCCESS = 'mailingLists/DELETE_SUCCESS';
export const DELETE_ERROR = 'mailingLists/DELETE_ERROR';

export const SET_ACTIVE_MAILING_LIST_ID = 'mailingLists/SET_ACTIVE_MAILING_LIST_ID';
